import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { AzureKeyVault } from './key-vault';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { validateAKVLinkedServiceReference } from '../../shared/utils/linkedservice-validation-util';

@Metamodel.model({
    name: ModelConstants.sapODataLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.SapOData_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.SapOData_DisplayText)
    ]
})
export class SapODataLinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    public static readonly HOST_URL: IAttribute;
    public static readonly CATALOG_SERVICE_PATH: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly LANGUAGE: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly CLIENT_ID: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Host,
        association: 'HOST_URL',
        templatable: true
    })
    public hostUrl?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_CatalogServicePath,
        association: 'CATALOG_SERVICE_PATH',
        templatable: true
    })
    public catalogServicePath?: string = '/sap/opu/odata/IWFND/CATALOGSERVICE;v=2/';

    @Metamodel.attribute({
        display: shellStringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Language,
        association: 'LANGUAGE',
        templatable: true
    })
    public language?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'PASSWORD',
        templatable: true
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ClientId,
        association: 'CLIENT_ID',
        templatable: true
    })
    public clientId?: string | AzureKeyVault;
}
